(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[572],{

/***/ 5737:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/go/[usercode]",
      function () {
        return __webpack_require__(494);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5527:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2322);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3255);
/* harmony import */ var _bubble_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9637);
/* harmony import */ var _bubble_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_bubble_module_scss__WEBPACK_IMPORTED_MODULE_3__);





function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Bubble = function(_param) {
    var as = _param.as, className = _param.className, props = _objectWithoutProperties(_param, [
        "as",
        "className"
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({
        as: as,
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(_bubble_module_scss__WEBPACK_IMPORTED_MODULE_3__.bubble, className)
    }, props)));
};
Bubble.propTypes = {
    as: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().node),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string)
};
Bubble.defaultProps = {
    as: 'span'
};
/* harmony default export */ __webpack_exports__["Z"] = (Bubble);


/***/ }),

/***/ 6752:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2322);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(959);
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_button_module_scss__WEBPACK_IMPORTED_MODULE_3__);





function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var Button = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function(_param, ref) {
    var children = _param.children, className = _param.className, href = _param.href, _iconAlt = _param.iconAlt, iconAlt = _iconAlt === void 0 ? '' : _iconAlt, iconSrc = _param.iconSrc, _size = _param.size, size = _size === void 0 ? 'medium' : _size, theme = _param.theme, props = _objectWithoutProperties(_param, [
        "children",
        "className",
        "href",
        "iconAlt",
        "iconSrc",
        "size",
        "theme"
    ]);
    var ref1 = _slicedToArray(href ? [
        'a',
        {
            href: href
        }
    ] : [
        'button',
        {}
    ], 2), As = ref1[0], asProps = ref1[1];
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(As, _objectSpread({}, props, asProps, {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(className, _button_module_scss__WEBPACK_IMPORTED_MODULE_3__.button, _button_module_scss__WEBPACK_IMPORTED_MODULE_3__[size], _button_module_scss__WEBPACK_IMPORTED_MODULE_3__[theme]),
        ref: ref,
        children: [
            iconSrc && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                className: _button_module_scss__WEBPACK_IMPORTED_MODULE_3__.icon,
                src: iconSrc,
                alt: iconAlt
            }),
            children
        ]
    })));
});
Button.displayName = 'Button';
Button.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().node.isRequired),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    href: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    iconAlt: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    iconSrc: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    size: prop_types__WEBPACK_IMPORTED_MODULE_4___default().oneOf([
        'small',
        'medium',
        'large',
        'full'
    ]),
    theme: prop_types__WEBPACK_IMPORTED_MODULE_4___default().oneOf([
        'blue',
        'light',
        'midnight',
        'outline'
    ]).isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 3576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ cta; }
});

// UNUSED EXPORTS: CTAQRCode

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(2779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(3980);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../../node_modules/qrcode.react/lib/index.js
var lib = __webpack_require__(1498);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./src/components/buttons/button.js
var buttons_button = __webpack_require__(6752);
;// CONCATENATED MODULE: ./src/images/icons/apple.svg
/* harmony default export */ var apple = ("data:image/svg+xml;base64,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");
;// CONCATENATED MODULE: ./src/images/icons/android.svg
/* harmony default export */ var android = ("data:image/svg+xml;base64,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");
// EXTERNAL MODULE: ./src/components/buttons/cta.module.scss
var cta_module = __webpack_require__(4132);
;// CONCATENATED MODULE: ./src/components/buttons/cta.js








// This needs to be set here since it drives the rendering of the qr.
// Match the CSS for best results.
var qrSize = 74;
var CTAQRCode = function(param) {
    var keyword = param.keyword;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: cta_module.or,
                        children: "or"
                    }),
                    " text ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: keyword
                    }),
                    " to",
                    ' ',
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "50409"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
                className: cta_module.qr,
                size: qrSize,
                bgColor: 'transparent',
                value: "smsto:50409?&body=".concat(encodeURIComponent(keyword))
            })
        ]
    }));
};
// Buttons that start a Resist.bot conversation right away
var ResistCTAButtons = function(param) {
    var className = param.className, _keyword = param.keyword, keyword = _keyword === void 0 ? 'resist' : _keyword, _theme = param.theme, theme = _theme === void 0 ? 'blue' : _theme;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()(cta_module.ctaBlock, className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons_button/* default */.Z, {
                theme: theme,
                href: "https://bcrw.apple.com/sms:open?service=iMessage&recipient=urn:biz:d0189b65-f844-4344-adc1-d2d01daca04e&body=".concat(keyword),
                iconSrc: apple,
                children: "iMessage"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons_button/* default */.Z, {
                theme: theme,
                href: "sms:50409?&body=".concat(keyword),
                iconSrc: android,
                children: "Text"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CTAQRCode, {
                keyword: keyword
            })
        ]
    }));
};
CTAQRCode.propTypes = {
    keyword: (prop_types_default()).string.isRequired
};
ResistCTAButtons.propTypes = {
    className: (prop_types_default()).string,
    keyword: (prop_types_default()).string,
    theme: (prop_types_default()).string
};
/* harmony default export */ var cta = (ResistCTAButtons);


/***/ }),

/***/ 6880:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2322);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _typography_text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(829);
/* harmony import */ var _DonationCount_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5712);
/* harmony import */ var _DonationCount_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_DonationCount_module_scss__WEBPACK_IMPORTED_MODULE_2__);




var DonationCount = function(param) {
    var count = param.count, text = param.text;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: _DonationCount_module_scss__WEBPACK_IMPORTED_MODULE_2__.donationCount,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: _DonationCount_module_scss__WEBPACK_IMPORTED_MODULE_2__.numbers,
                children: count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',').split('').map(function(letter, index) {
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_typography_text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        as: "span",
                        className: _DonationCount_module_scss__WEBPACK_IMPORTED_MODULE_2__.number,
                        children: letter
                    }, "".concat(letter, "-").concat(index));
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: _DonationCount_module_scss__WEBPACK_IMPORTED_MODULE_2__.text,
                children: text
            })
        ]
    }));
};
DonationCount.propTypes = {
    count: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number.isRequired),
    text: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string.isRequired)
};
/* harmony default export */ __webpack_exports__["Z"] = (DonationCount);


/***/ }),

/***/ 5127:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2322);
/* harmony import */ var components_typography_text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(829);
/* harmony import */ var components_typography_anchor__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8472);
/* harmony import */ var utilities_propTypes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4010);
/* harmony import */ var utilities_targets__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1512);
/* harmony import */ var _Petition_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4560);
/* harmony import */ var _Petition_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_Petition_module_scss__WEBPACK_IMPORTED_MODULE_5__);






var trending = function(sign_count_period) {
    if (sign_count_period) {
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_typography_text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    className: _Petition_module_scss__WEBPACK_IMPORTED_MODULE_5__.signCountPeriod,
                    children: sign_count_period.toLocaleString()
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_typography_text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    size: "small",
                    className: _Petition_module_scss__WEBPACK_IMPORTED_MODULE_5__.signCountDetail,
                    children: "7d"
                })
            ]
        }));
    }
    return null;
};
var Petition = function(param) {
    var petition = param.petition;
    var ref;
    var state = petition.state, target = petition.target, petition_code = petition.petition_code;
    var hasState = !!state;
    var stateDetail = "(".concat(state, " only) ");
    var targetDetail = (0,utilities_targets__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(target);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: _Petition_module_scss__WEBPACK_IMPORTED_MODULE_5__.petitionBase,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_typography_anchor__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            href: "/petitions/".concat(petition_code),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: _Petition_module_scss__WEBPACK_IMPORTED_MODULE_5__.petitionDetail,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_typography_text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            className: _Petition_module_scss__WEBPACK_IMPORTED_MODULE_5__.subject,
                            children: petition.subject
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_typography_text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            className: _Petition_module_scss__WEBPACK_IMPORTED_MODULE_5__.startedOn,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("em", {
                                    children: "to"
                                }),
                                " ",
                                "".concat(targetDetail, " "),
                                hasState ? stateDetail : ''
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: _Petition_module_scss__WEBPACK_IMPORTED_MODULE_5__.signatureCounts,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_typography_text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                    className: _Petition_module_scss__WEBPACK_IMPORTED_MODULE_5__.signCount,
                                    children: petition.sign_count.toLocaleString()
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_typography_text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                    size: "small",
                                    className: _Petition_module_scss__WEBPACK_IMPORTED_MODULE_5__.signCountDetail,
                                    children: "Signers"
                                })
                            ]
                        }),
                        trending(petition === null || petition === void 0 ? void 0 : (ref = petition.trending) === null || ref === void 0 ? void 0 : ref.sign_count_period)
                    ]
                })
            ]
        })
    }));
};
Petition.propTypes = {
    petition: utilities_propTypes__WEBPACK_IMPORTED_MODULE_3__/* .PetitionTypeList */ .iU
};
/* harmony default export */ __webpack_exports__["Z"] = (Petition);


/***/ }),

/***/ 3456:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ tabs; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(3980);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/components/tabs.module.scss
var tabs_module = __webpack_require__(8021);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(2779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/buttons/button.js
var buttons_button = __webpack_require__(6752);
// EXTERNAL MODULE: ./src/components/search/tabbutton.module.scss
var tabbutton_module = __webpack_require__(8369);
;// CONCATENATED MODULE: ./src/components/search/tabbutton.js






function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var TabButton = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var active = _param.active, className = _param.className, props = _objectWithoutProperties(_param, [
        "active",
        "className"
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(buttons_button/* default */.Z, _objectSpread({}, props, {
        className: classnames_default()(className, active && tabbutton_module.active, tabbutton_module.tabButton),
        ref: ref,
        size: "small",
        theme: "light"
    })));
});
TabButton.displayName = 'TabButton';
TabButton.propTypes = {
    active: (prop_types_default()).bool,
    className: (prop_types_default()).string
};
/* harmony default export */ var tabbutton = (TabButton);

;// CONCATENATED MODULE: ./src/images/x.svg
/* harmony default export */ var x = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNyAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGxpbmUgeDE9IjMiIHkxPSIxNCIgeDI9IjE0IiB5Mj0iMyIgc3Ryb2tlPSIjNzA3MDcwIiBzdHJva2Utd2lkdGg9IjEiLz4KPGxpbmUgeDE9IjMiIHkxPSIzIiB4Mj0iMTQiIHkyPSIxNCIgc3Ryb2tlPSIjNzA3MDcwIiBzdHJva2Utd2lkdGg9IjEiLz4KPC9zdmc+Cg==");
// EXTERNAL MODULE: ./src/components/search/searchbar.module.scss
var searchbar_module = __webpack_require__(4099);
;// CONCATENATED MODULE: ./src/components/search/searchbar.js






var inputId = 'search-bar-input';
var SearchBar = function(param) {
    var className = param.className, closeSearch = param.closeSearch, searchText = param.searchText, setSearchText = param.setSearchText;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()(className, searchbar_module.searchBar),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                className: searchbar_module.prompt,
                htmlFor: inputId,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "Search"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: searchbar_module.promptExtra,
                        children: "\xa0Search\xa0for\xa0what\xa0you’d\xa0like\xa0resistbot\xa0to\xa0do:"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: searchbar_module.inputs,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        "aria-label": "Search resistbot commands",
                        className: searchbar_module.searchInput,
                        id: inputId,
                        onChange: function(event) {
                            return setSearchText(event.target.value);
                        },
                        onKeyDown: function(event) {
                            // Escape key
                            if (event.keyCode === 27) {
                                closeSearch();
                            }
                        },
                        ref: function(input) {
                            return input === null || input === void 0 ? void 0 : input.focus();
                        },
                        type: "text",
                        value: searchText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(tabbutton, {
                        "aria-label": "Close search",
                        className: searchbar_module.closer,
                        onClick: closeSearch,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            alt: "",
                            src: x
                        })
                    })
                ]
            })
        ]
    }));
};
SearchBar.propTypes = {
    className: (prop_types_default()).string,
    closeSearch: (prop_types_default()).func.isRequired,
    searchText: (prop_types_default()).string.isRequired,
    setSearchText: (prop_types_default()).func.isRequired
};
/* harmony default export */ var searchbar = (SearchBar);

;// CONCATENATED MODULE: ./src/images/magnifier.svg
/* harmony default export */ var magnifier = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNyAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGxpbmUgeDE9IjEuMjkyODkiIHkxPSIxNi4wMzk4IiB4Mj0iOC43OTU2NCIgeTI9IjguNTM3MDYiIHN0cm9rZT0iIzcwNzA3MCIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxjaXJjbGUgY3g9IjEwLjYyMjciIGN5PSI2LjM3NzM0IiByPSI1Ljg3NzM0IiBmaWxsPSJ3aGl0ZSIgc3Ryb2tlPSIjNzA3MDcwIi8+Cjwvc3ZnPgo=");
// EXTERNAL MODULE: ./src/components/search/searchicon.module.scss
var searchicon_module = __webpack_require__(4635);
;// CONCATENATED MODULE: ./src/components/search/searchicon.js






var SearchIcon = function(param) {
    var className = param.className, closingSearch = param.closingSearch, openSearch = param.openSearch;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(tabbutton, {
        "aria-label": "Open search",
        className: classnames_default()(searchicon_module.searchIcon, className),
        onClick: openSearch,
        ref: function(button) {
            return closingSearch && (button === null || button === void 0 ? void 0 : button.focus());
        },
        size: "small",
        theme: "light",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            alt: "",
            src: magnifier
        })
    }));
};
SearchIcon.propTypes = {
    className: (prop_types_default()).string,
    closingSearch: (prop_types_default()).bool,
    openSearch: (prop_types_default()).func.isRequired
};
/* harmony default export */ var searchicon = (SearchIcon);

;// CONCATENATED MODULE: ./src/components/search/useexpandablesearch.js




var useExpandableSearch = function() {
    var className = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : '';
    var ref = (0,react.useState)(false), closingSearch = ref[0], setClosingSearch = ref[1];
    var ref1 = (0,react.useState)(false), searching = ref1[0], setSearching = ref1[1];
    var ref2 = (0,react.useState)(''), searchText = ref2[0], setSearchText = ref2[1];
    (0,react.useEffect)(function() {
        if (closingSearch) {
            setClosingSearch(false);
        }
    }, [
        closingSearch
    ]);
    (0,react.useEffect)(function() {
        if (searchText && !searching) {
            setSearchText('');
        }
    }, [
        searching,
        searchText
    ]);
    var searcher = searching ? /*#__PURE__*/ (0,jsx_runtime.jsx)(searchbar, {
        className: className,
        searchText: searchText,
        closeSearch: function() {
            setClosingSearch(true);
            setSearching(false);
        },
        setSearchText: setSearchText
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(searchicon, {
        className: className,
        closingSearch: closingSearch,
        openSearch: function() {
            return setSearching(true);
        }
    });
    return {
        searcher: searcher,
        searching: searching,
        searchText: searchText
    };
};
/* harmony default export */ var useexpandablesearch = (useExpandableSearch);

;// CONCATENATED MODULE: ./src/components/tabs.js






var Tabs = function(param1) {
    var className = param1.className, descriptor = param1.descriptor, renderSearch = param1.renderSearch, sections = param1.sections, searchDisabled = param1.searchDisabled;
    var ref = (0,react.useState)(0), activeIndex = ref[0], setActiveIndex = ref[1];
    var ref1 = useexpandablesearch(), searcher = ref1.searcher, searching = ref1.searching, searchText = ref1.searchText;
    var activeSection = sections[activeIndex];
    var id = function(type, index) {
        return "".concat(descriptor, "-").concat(type, "-").concat(sections[index].title).replace(/\s+/gi, '');
    };
    if (searching && !searchDisabled) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: className,
            children: [
                searcher,
                renderSearch(searchText)
            ]
        }));
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: tabs_module.buttons,
                "aria-label": "".concat(descriptor, " tabs"),
                role: "tablist",
                children: [
                    sections.map(function(param, index) {
                        var title = param.title;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(tabbutton, {
                            "aria-controls": id('panel', index),
                            "aria-selected": index === activeIndex,
                            active: index === activeIndex,
                            id: id('tab', index),
                            onClick: function() {
                                return setActiveIndex(index);
                            },
                            role: "tab",
                            children: title
                        }, title);
                    }),
                    !searchDisabled ? searcher : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                "aria-labelledby": id('tab', activeIndex),
                id: id('panel', activeIndex),
                role: "tabpanel",
                children: activeSection.contents
            })
        ]
    }));
};
Tabs.propTypes = {
    className: (prop_types_default()).string,
    descriptor: (prop_types_default()).string.isRequired,
    sections: prop_types_default().oneOfType([
        (prop_types_default()).array,
        (prop_types_default()).node
    ]).isRequired,
    renderSearch: (prop_types_default()).func,
    searchDisabled: (prop_types_default()).bool.isRequired
};
Tabs.defaultProps = {
    searchDisabled: false
};
/* harmony default export */ var tabs = (Tabs);


/***/ }),

/***/ 494:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2322);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(3980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var components_donation_counts_DonationCount__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6880);
/* harmony import */ var components_layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8492);
/* harmony import */ var components_bubble__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5527);
/* harmony import */ var components_typography_heading__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9852);
/* harmony import */ var components_typography_text__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(829);
/* harmony import */ var components_typography_anchor__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8472);
/* harmony import */ var components_tabs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3456);
/* harmony import */ var components_petition_Petition__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5127);
/* harmony import */ var components_buttons_cta__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(3576);
/* harmony import */ var images_shares_petition_share_png__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(4611);
/* harmony import */ var utilities_propTypes__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4010);
/* harmony import */ var _go_module_scss__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(2754);
/* harmony import */ var _go_module_scss__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_go_module_scss__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _common_petitions_module_scss__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(877);
/* harmony import */ var _common_petitions_module_scss__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_common_petitions_module_scss__WEBPACK_IMPORTED_MODULE_13__);















function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var BASE_PATH = 'go';
var User = function(param) {
    var usercode = param.usercode, open = param.open, closed = param.closed, signCount = param.signCount;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        title: "@".concat(usercode, " on Resistbot"),
        description: "Join the campaigns @".concat(usercode, " is running on Resistbot!"),
        image: images_shares_petition_share_png__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z,
        imageAltText: "Text Follow ".concat(usercode, " to 50409"),
        canonicalPath: "/".concat(BASE_PATH, "/").concat(usercode.toLowerCase()),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: _go_module_scss__WEBPACK_IMPORTED_MODULE_12__.profile,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: _go_module_scss__WEBPACK_IMPORTED_MODULE_12__.about,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_typography_heading__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                as: "h1",
                                size: "h2",
                                children: [
                                    "@",
                                    usercode
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_typography_text__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                children: [
                                    "Here are the campaigns @",
                                    usercode,
                                    " has organized, text",
                                    ' ',
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_bubble__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        children: [
                                            "Go ",
                                            usercode
                                        ]
                                    }),
                                    " to see these on Resistbot, or",
                                    ' ',
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_bubble__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        children: [
                                            "Follow ",
                                            usercode
                                        ]
                                    }),
                                    " to be alerted to new campaigns."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: _go_module_scss__WEBPACK_IMPORTED_MODULE_12__.stats,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_donation_counts_DonationCount__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            count: signCount,
                            text: "Total Signers"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PetitionsGroup, {
                open: open,
                closed: closed,
                usercode: usercode
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CTA, {
                sharecode: usercode
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_typography_text__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                children: [
                    "Want your own Resistbot keyword and a page like this one?",
                    ' ',
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_typography_anchor__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        href: "/donate?monthly=true",
                        children: "Become a monthly\xa0donor!"
                    })
                ]
            })
        ]
    }));
};
var PetitionsGroup = function(param) {
    var open = param.open, closed = param.closed, usercode = param.usercode;
    var openGroup = open.map(function(petition) {
        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_petition_Petition__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            petition: petition
        }, petition.petition_code);
    });
    var closedGroup = closed.map(function(petition) {
        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_petition_Petition__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            petition: petition
        }, petition.petition_code);
    });
    var hasOpen = open.length > 0;
    var hasClosed = closed.length > 0;
    var hasBoth = hasOpen && hasClosed;
    var hasNone = !hasOpen && !hasClosed;
    var openTabText = hasOpen ? "Open (".concat(open.length, ")") : "Open";
    var closedTabText = hasClosed ? "Closed (".concat(closed.length, ")") : "Closed";
    // None of each
    if (hasNone) {
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: _go_module_scss__WEBPACK_IMPORTED_MODULE_12__.empty,
            children: [
                "Follow @",
                usercode,
                " to receive a text when they launch their first campaign, or see ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_typography_anchor__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    href: "/petitions",
                    children: "top campaigns"
                }),
                ' ',
                "organized by other\xa0members."
            ]
        }));
    }
    // Some of both
    if (hasBoth) {
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_tabs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            descriptor: "petition types",
            searchDisabled: true,
            sections: [
                {
                    contents: openGroup,
                    title: openTabText
                },
                {
                    contents: closedGroup,
                    title: closedTabText
                }, 
            ]
        }));
    }
    // Only open
    if (hasOpen && !hasClosed) {
        return openGroup;
    }
    // Only closed
    if (!hasOpen && hasClosed) {
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_tabs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            descriptor: "petition types",
            searchDisabled: true,
            sections: [
                {
                    contents: openGroup,
                    title: openTabText
                },
                {
                    contents: closedGroup,
                    title: closedTabText
                }, 
            ]
        }));
    }
};
var CTA = function(param) {
    var sharecode = param.sharecode, _is_closed = param.is_closed, is_closed = _is_closed === void 0 ? false : _is_closed;
    var params = !is_closed ? {
        keyword: "follow ".concat(sharecode)
    } : {};
    var heading = !is_closed ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_typography_heading__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        as: "h2",
        className: _common_petitions_module_scss__WEBPACK_IMPORTED_MODULE_13__.ctaHeading,
        size: "h2",
        children: [
            "Follow @",
            sharecode
        ]
    }) : null;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: _common_petitions_module_scss__WEBPACK_IMPORTED_MODULE_13__.cta,
        children: [
            heading,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_buttons_cta__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, _objectSpread({}, params))
        ]
    }));
};
CTA.propTypes = {
    sharecode: (prop_types__WEBPACK_IMPORTED_MODULE_14___default().string.isRequired),
    is_closed: (prop_types__WEBPACK_IMPORTED_MODULE_14___default().bool)
};
User.propTypes = {
    usercode: (prop_types__WEBPACK_IMPORTED_MODULE_14___default().string.isRequired),
    open: prop_types__WEBPACK_IMPORTED_MODULE_14___default().arrayOf(utilities_propTypes__WEBPACK_IMPORTED_MODULE_10__/* .PetitionTypeList */ .iU).isRequired,
    closed: prop_types__WEBPACK_IMPORTED_MODULE_14___default().arrayOf(utilities_propTypes__WEBPACK_IMPORTED_MODULE_10__/* .PetitionTypeList */ .iU).isRequired,
    signCount: (prop_types__WEBPACK_IMPORTED_MODULE_14___default().number.isRequired)
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (User);


/***/ }),

/***/ 4010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T7": function() { return /* binding */ BlogPostDetailType; },
/* harmony export */   "XW": function() { return /* binding */ BlogPostTileType; },
/* harmony export */   "bg": function() { return /* binding */ LetterType; },
/* harmony export */   "WT": function() { return /* binding */ SiteStatsType; },
/* harmony export */   "Ni": function() { return /* binding */ PetitionType; },
/* harmony export */   "iU": function() { return /* binding */ PetitionTypeList; },
/* harmony export */   "Y4": function() { return /* binding */ MerchType; },
/* harmony export */   "Jp": function() { return /* binding */ SanityMerchImageType; },
/* harmony export */   "FO": function() { return /* binding */ KeywordType; }
/* harmony export */ });
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var utilities_proptype_validators__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9685);


var SanityImageType = prop_types__WEBPACK_IMPORTED_MODULE_0___default().shape({
    alt: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    asset: prop_types__WEBPACK_IMPORTED_MODULE_0___default().shape({
        url: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired)
    }).isRequired
}).isRequired;
var SanityMerchImageType = prop_types__WEBPACK_IMPORTED_MODULE_0___default().shape({
    altText: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    asset: prop_types__WEBPACK_IMPORTED_MODULE_0___default().shape({
        url: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired)
    }).isRequired
}).isRequired;
var BlogPostDetailType = prop_types__WEBPACK_IMPORTED_MODULE_0___default().exact({
    id: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    slug: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    route: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    publishedAt: utilities_proptype_validators__WEBPACK_IMPORTED_MODULE_1__/* .ISODateValidator */ .L,
    lastUpdated: utilities_proptype_validators__WEBPACK_IMPORTED_MODULE_1__/* .ISODateValidator */ .L,
    title: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    description: prop_types__WEBPACK_IMPORTED_MODULE_0___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_0___default().shape({})).isRequired,
    mainImage: SanityImageType,
    body: prop_types__WEBPACK_IMPORTED_MODULE_0___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_0___default().shape({})).isRequired,
    featuredKeyword: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),
    authors: prop_types__WEBPACK_IMPORTED_MODULE_0___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_0___default().exact({
        name: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired)
    })),
    category: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    tags: prop_types__WEBPACK_IMPORTED_MODULE_0___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_0___default().shape({}))
}).isRequired;
var BlogPostTileType = prop_types__WEBPACK_IMPORTED_MODULE_0___default().exact({
    id: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    slug: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    route: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    publishedAt: utilities_proptype_validators__WEBPACK_IMPORTED_MODULE_1__/* .ISODateValidator */ .L,
    title: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    description: prop_types__WEBPACK_IMPORTED_MODULE_0___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_0___default().shape({})).isRequired,
    mainImage: SanityImageType,
    category: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired)
}).isRequired;
var LetterType = (prop_types__WEBPACK_IMPORTED_MODULE_0___default().object);
var SiteStatsType = prop_types__WEBPACK_IMPORTED_MODULE_0___default().exact({
    lettersSent: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().number.isRequired),
    recurringDonors: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().number.isRequired),
    targetRecurringDonors: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().number.isRequired),
    users: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().number.isRequired),
    voterRegistrations: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().number.isRequired)
});
var PetitionType = prop_types__WEBPACK_IMPORTED_MODULE_0___default().exact({
    petition_code: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    petitioner_code: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),
    subject: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    message: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    petitioner_name: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    state: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),
    sent_timestamp: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().number.isRequired),
    target: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    sign_count: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().number.isRequired),
    sign_status: prop_types__WEBPACK_IMPORTED_MODULE_0___default().oneOf([
        'open',
        'closed'
    ]),
    trending: prop_types__WEBPACK_IMPORTED_MODULE_0___default().exact({
        sign_count_period: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().number)
    }).isRequired
});
var PetitionTypeList = prop_types__WEBPACK_IMPORTED_MODULE_0___default().exact({
    petition_code: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    subject: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    state: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),
    sent_timestamp: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().number.isRequired),
    target: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    sign_count: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().number.isRequired),
    sign_status: prop_types__WEBPACK_IMPORTED_MODULE_0___default().oneOf([
        'open',
        'closed'
    ]),
    trending: prop_types__WEBPACK_IMPORTED_MODULE_0___default().exact({
        sign_count_period: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().number)
    })
});
var MerchType = prop_types__WEBPACK_IMPORTED_MODULE_0___default().exact({
    _id: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    image: SanityMerchImageType,
    name: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    link: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired)
});
var KeywordType = prop_types__WEBPACK_IMPORTED_MODULE_0___default().shape({
    keyword: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string.isRequired),
    description: prop_types__WEBPACK_IMPORTED_MODULE_0___default().arrayOf((prop_types__WEBPACK_IMPORTED_MODULE_0___default().object))
});



/***/ }),

/***/ 1512:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var TARGET_TYPES = {
    all: '',
    national_all: 'the President and U.S. Congress',
    congress: 'the U.S. Congress',
    senior: 'the U.S. Senate',
    junior: 'the U.S. Senate',
    senate: 'the U.S. Senate',
    house: 'the U.S. House of Representatives',
    president: 'the President',
    state_all: 'State Governors & Legislatures',
    governor: 'State Governors',
    state_legislature: 'State Legislatures',
    state_upper: 'State Senates',
    state_lower: 'State Legislatures',
    dnc: 'the Democratic National Committee',
    governor_senate: 'State Governors and the U.S. Senate',
    obama: 'President Obama',
    mayor: 'Mayors',
    ceo: 'State Election Officials'
};
var getTargetTypeHumanName = function(abbreviation) {
    var abbrev = abbreviation.toLowerCase();
    return TARGET_TYPES[abbrev] || '';
};
/* harmony default export */ __webpack_exports__["Z"] = (getTargetTypeHumanName);


/***/ }),

/***/ 9637:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bubble":"bubble_bubble__Zpq6_"};

/***/ }),

/***/ 959:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__min1b","small":"button_small__9ZMRl","medium":"button_medium__bH1Hz","large":"button_large__UygIj","full":"button_full__ATHy_","icon":"button_icon__imq3_","blue":"button_blue__tBWUT","light":"button_light__5OWv6","midnight":"button_midnight__4HV6B","outline":"button_outline__VnTGJ"};

/***/ }),

/***/ 4132:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ctaBlock":"cta_ctaBlock__iXsYL","or":"cta_or__Oeebd","ctaHeading":"cta_ctaHeading__wWUnB","qr":"cta_qr__lJ4lF"};

/***/ }),

/***/ 5712:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"donationCount":"DonationCount_donationCount__5IKZ3","numbers":"DonationCount_numbers__S3XfP","number":"DonationCount_number__EaQXg","text":"DonationCount_text__tQQsT"};

/***/ }),

/***/ 4560:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"petitionBase":"Petition_petitionBase__ccYdR","subject":"Petition_subject__Z9M76","startedOn":"Petition_startedOn__eZm5o","signCountDetail":"Petition_signCountDetail__ULhJq","petitionDetail":"Petition_petitionDetail__RgdwS","signatureCounts":"Petition_signatureCounts__9XCWU","signCount":"Petition_signCount__Lihvc","signCountPeriod":"Petition_signCountPeriod___Zcmd"};

/***/ }),

/***/ 4099:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"searchBar":"searchbar_searchBar__dS_u3","searchInput":"searchbar_searchInput__wKOVD","closer":"searchbar_closer__6nNx2","prompt":"searchbar_prompt__XYUSM","promptExtra":"searchbar_promptExtra__zNopV","inputs":"searchbar_inputs__4Mqzw"};

/***/ }),

/***/ 4635:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"searchIcon":"searchicon_searchIcon__yrvPw"};

/***/ }),

/***/ 8369:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tabButton":"tabbutton_tabButton__gj7ng","active":"tabbutton_active__XyZnf"};

/***/ }),

/***/ 8021:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"buttons":"tabs_buttons__7RK4r"};

/***/ }),

/***/ 877:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cta":"petitions_cta__u8CHJ","ctaHeading":"petitions_ctaHeading__Bg_bj"};

/***/ }),

/***/ 2754:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"stats":"go_stats__A29g0","profile":"go_profile__5p7nw","about":"go_about__H50L3","empty":"go_empty__Afgmd"};

/***/ }),

/***/ 4611:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ("/_next/static/images/petition-share-3757b63a2e1ca42da7a3c50cc4268a0e.png");

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [569,193,498,323,774,888,179], function() { return __webpack_exec__(5737); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);